"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfOrientationOpportunitySearchResultItemDto = instanceOfPaginatedResponseOfOrientationOpportunitySearchResultItemDto;
exports.PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSON = PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSON;
exports.PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSONTyped = PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSONTyped;
exports.PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSON = PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSON;
exports.PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSONTyped = PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSONTyped;
const OrientationOpportunitySearchResultItemDto_1 = require("./OrientationOpportunitySearchResultItemDto");
const PaginationMetaDto_1 = require("./PaginationMetaDto");
/**
 * Check if a given object implements the PaginatedResponseOfOrientationOpportunitySearchResultItemDto interface.
 */
function instanceOfPaginatedResponseOfOrientationOpportunitySearchResultItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSON(json) {
    return PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfOrientationOpportunitySearchResultItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(OrientationOpportunitySearchResultItemDto_1.OrientationOpportunitySearchResultItemDtoFromJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSON(json) {
    return PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfOrientationOpportunitySearchResultItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(OrientationOpportunitySearchResultItemDto_1.OrientationOpportunitySearchResultItemDtoToJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfOrientationOpportunitySearchResultItemDto.js.map